import { type MoneyAmount } from 'types'
import { getMinifiedLocaleCurrencyStringFromMoneyAmount } from 'utils'

type Props = {
  balance: MoneyAmount;
}

export const CurrentBalance = ({ balance }: Props) => {
  return (
    <div className='flex flex-col gap-1'>
      <div className='flex flex-row justify-between gap-2'>
        <span className='body-bold'>Thatch balance</span>
        <span className='body-bold'>{getMinifiedLocaleCurrencyStringFromMoneyAmount(balance)}</span>
      </div>
    </div>
  )
}
